import Ajax from "Utils/ajax";
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data); 
export const getStaffNetPayReport = (data) => Ajax.post('hr/getStaffNetPayReport',data);